import { AfterContentInit, booleanAttribute, Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[ptInlineSuccess]',
  standalone: true
})
export class InlineSuccessDirective implements AfterContentInit {

  @Input({ transform: booleanAttribute }) ptInlineSuccess?: boolean;

  constructor(private el: ElementRef, private renderer: Renderer2) {
  }


  ngAfterContentInit(): void {
    this.el.nativeElement.addEventListener("click", () => {
      const check = document.createElement('div');
      check.style.borderRadius = '50%';
      check.style.marginRight = '5px';
      check.style.fontWeight = 'bold';
      check.style.color = 'inherit';
      check.style.transition = 'color 300 ms'
      check.innerHTML = '&check;';
      const btn = this.el.nativeElement as Element;
      btn.classList.add('disabled');
      btn.prepend(check);
      setTimeout(() => {
        check.style.color = '#13880b';
      }, 200);
      setTimeout(() => {
        btn.classList.remove('disabled');
        btn.removeChild(check);
      }, 500);
    });
  }

}
